import { withStyles, Drawer, withTheme } from "@material-ui/core";
import styles from "./styles";
import { compose } from "recompose";

const DispatchDrawer = ({
  classes,
  open,
  anchor,
  variant,
  theme,
  BackdropProps,
  drawerClasses,
  children,
  customModalClasses,
  customDrawerPaperClasses,
  applyDrawerShadow=false
}) => {
  return (
    <Drawer
      variant={variant ?? "temporary"}
      role="dialog"
      anchor={anchor ?? "right"}
      open={open}
      classes={drawerClasses ?? {
        paper: `${classes.paperAnchor} ${customDrawerPaperClasses ?? classes.drawerPaper} ${
          !open ? classes.paperHidden : ""
        }`,
        modal: `${customModalClasses ?? classes.modal} ${theme.themeName}`,
        paperAnchorRight: applyDrawerShadow ? classes.applyDrawerShadow : classes.hideDrawerShadow,
      }}
      ModalProps={{
        disableEnforceFocus: true, // Prevent focus trapping
      }}
      BackdropProps={BackdropProps ?? {
        className: classes.nonTransparentBackdrop,
      }}
    >
      {children}
    </Drawer>
  );
};

export default compose(withStyles(styles), withTheme())(DispatchDrawer);
